import { css, html, LitElement } from "lit";
import templateJsonStore from "./TemplateJsonStore.js";
import templateSelectedItemStore from "./TemplateSelectedItemStore.js";
import { selectItem, deselectItem } from "./TemplateSelectedItemSlice.js"
import { addTemplate, clearTrashbox, copyElement, findElementById, findNextSibling, findParentById, moveAfter, moveToTrashbox, updateElementAttribute, updateExpand, insertAsChild } from "./TemplateJsonSlice.js";
import templateSelectedRootStore from "./TemplateSelectedRootStore.js";
import { selectRoot } from "./TemplateSelectedRootSlice.js";
import { TemplateDragController } from "./TemplateDragController.js";
import { v4 } from "uuid";
import templateCopyItemStore from "./TemplateCopyItemStore.js";
import { deselectCopyItem, selectCopyItem } from "./TemplateCopyItemSlice.js";
import './TemplateTrashBox.js';
import './InsertPointTooltip.js';
import './TemplateSearchSubWindow.js';
import alertStore from "./AlertStore.js";
import { setAlert } from "./AlertSlice.js";
import { templateHistoryManager } from './TemplateHistoryManager.js';
import scriptItemStore from "./ScriptItemStore.js";
import { addNewScript } from "./ScriptItemSlice.js";
import eventItemStore from "./EventItemStore.js";
import { addScriptToExistingTag, addNewTag as addNewEventTag, addEventToExistingTag } from "./EventItemSlice.js";
import userSettingStore from "./UserSettingStore.js";

class TemplateContainer extends LitElement {

  static styles = css`
        :host {
            --main-padding: 10px;
            --main-margin: 10px;
            --main-gap: 10px;
            --sub-padding: 5px;
            --sub-margin: 5px;
            display: block;
            background-color: #f7f7f7;
            border-radius: 10px;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
            padding: var(--main-padding);
            margin: var(--main-margin);
            padding-top: 0;
            position: fixed;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }

        select {
          min-width: 100px;
        }
        
        .title-bar {
          min-width: 250px;
          color: rgb(84, 84, 84);
          text-align: center;
          border-bottom: 1px solid #cfcfcf;
          padding-top: var(--sub-padding);
          padding-bottom: var(--sub-padding);
          margin-bottom: var(--sub-margin);
          user-select: none;
          position: relative;
        }

        .title-icon-bar {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
        }

        .title-icon-bar-left, .title-icon-bar-right {
          display: flex;
          gap: 5px;
        }

        .title-icon-bar-button {
          border-radius: 50%;
          border: 1px solid #c7c7c7;
          height: 28px;
          width: 28px;
          color: #878787;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .title-icon-bar-button:hover:not(:disabled) {
          background-color: #e0e0e0;
          color: #333;
        }

        .title-icon-bar-button:disabled {
          background-color: #f9f9f9;
          color: #d1d1d1;
          border-color: #e5e5e5;
          cursor: not-allowed;
        }
        
        /* Style for the title text */
        .title {
            font-size: 18px;
            font-weight: bold;
        }
        
        .panel {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          /* スクロールを無効化し、はみ出しを隠す */
          overflow: hidden;
        }

        .container {
          min-width: 250px;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          gap: --main-gap;
          border: 1px solid #ccc;
          padding: var(--main-padding);
          padding-bottom: 0;
          background-color: #fff;
          box-sizing: border-box; 
          user-select: none;
          border-radius: 0px 0px var(--sub-margin) var(--sub-margin);
          /* 外側のスクロールを無効化 */
          overflow: hidden;
        }

        .top-container{
          display:flex;
          justify-content: space-between;
          margin-bottom: 10px;
          align-items: stretch;
          /* スクロールによって高さが潰れないように設定 */
          flex-shrink: 0;
        }

        /* ----- ツリー部分のみをスクロール可能にする ----- */
        #dom-tree {
          flex-grow: 1;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          padding-right: 5px;
          padding-bottom: 30px; /* アイテムウィンドウなどに隠れないように余白確保 */
        }

        /* --- Empty State --- */
        .empty-state-container {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          padding: 20px;
          margin: 10px;
          border: 2px dashed #d1d5db;
          border-radius: 12px;
          background-color: #f9fafb;
          text-align: center;
        }
        .empty-state-title {
          font-weight: 800;
          color: #374151;
          margin-bottom: 8px;
        }
        .empty-state-desc {
          font-size: 12px;
          color: #6b7280;
          margin-bottom: 16px;
        }
        .empty-state-btn {
          background-color: white;
          border: 1px solid #d1d5db;
          padding: 10px;
          border-radius: 8px;
          margin-bottom: 8px;
          cursor: pointer;
          font-size: 13px;
          font-weight: bold;
          color: #4b5563;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        .empty-state-btn:hover {
          background-color: #f3f4f6;
          border-color: #9ca3af;
          transform: translateY(-1px);
        }
        .empty-state-btn.ai-btn {
          background: linear-gradient(135deg, #e0c3fc 0%, #8ec5fc 100%);
          color: #fff;
          border: none;
        }
        .empty-state-btn.ai-btn:hover {
          filter: brightness(0.95);
        }
    
        .hamburger-wrapper {
          position: relative;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hamburger {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 20px;
          height: 20px;
          cursor: pointer;
          border-radius: 50%;
          border: 2px solid rgb(135, 135, 135);
          padding: 5px;
          box-sizing: content-box;
          align-items: center;
        }

        .hamburger i {
          font-size: 20px;
          color: rgb(135, 135, 135);
        }

        .bar {
          width: 20px;
          height: 4px;
          background-color: rgb(135, 135, 135);
          border-radius: 2px;
        }
        .context-menu {
          display: none;
          position: fixed;
          background: #000000c4;
          border-radius: 4px;
          box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
          z-index: 100;
        }
        .menu-item {
          padding: 12px 20px;
          color: rgb(255 255 255);
          font-size: 16px;
          cursor: pointer;
          transition: background-color 0.3s ease;
          border-bottom: 1px solid #dfdfdf;
        }
        .menu-item:hover {
          background-color: rgb(255 255 255 / 70%);
          color: rgb(0 0 0);
        }

        .node {
          border: 1px solid #ccc;
          padding: 0px 0px 0px 10px;
          margin: 2px 2px 20px 2px;
          background-color: #f9f9f9;
          border-radius: 5px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          padding-right: 0px;
          margin-right: 0px;
          position: relative;
          user-select: none;
        }

        .node-select {
          cursor: grab;
          background: #eff2ff;
        }
    
        .node-select-parent::after {
          content: "";
          display: block;
          width: 100%;
          height: 100%;
          outline: 3px dashed #8694f5;
          border-radius: 5px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none; 
        }

        .node-select::after {
          content: "";
          display: block;
          width: 100%;
          height: 100%;
          outline: 3px solid #8694f5;
          border-radius: 5px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none; 
        }

        .node-add-point{
          visibility: hidden;
          width: 90%;
          border-bottom: 2px dashed rgb(125, 109, 255);
          position: absolute;
          transform: translateY(-10px);
          z-index: 1000;
        }

        .node-add-point-selected{
          visibility: visible;
        }

        .node-pre-add::before{
          content: "";
          display: block;
          position: absolute;
          width: 90%;
          border-bottom: 2px dashed rgb(125, 109, 255);
          bottom: -7px;
        }
        

        .node-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-bottom: 5px;
        }
        
        .node-title-left {
          display: flex;
          flex-direction: column;
        }
        
        .node-title-right {
          display: flex;
          align-items: center;
        }
        
        .label-id {
          font-size: small;
          color: #917bff;
        }

        .label-tag-container {
          display: flex;
          flex-direction: row;
          align-items: flex-end;
          flex-wrap: nowrap;
        }

        .node .clear-icon,
        .node .copy-icon {
          visibility: hidden;
          width: 20px;
          height: 20px;
        }

        .node-select > .node-title > .node-title-right{
          display: flex;
          align-items: center;
          margin-top: 3px;
        }
        
        .node-select > .node-title > .node-title-right > .clear-icon,
        .node-select > .node-title > .node-title-right > .copy-icon
         {
          display: flex;
          visibility: visible;
          margin-right: 10px;
          color: rgb(203 90 90);
          cursor: pointer;
          border: 2px solid;
          border-radius: 100%;
          padding: 5px;
          background: #ffdbdb;
          font-size: 20px;
          justify-content: center;
        }

        .node-select > .node-title > .node-title-right > .copy-icon {
          color: #7789bf;
          background: #f7f8fb;
        }

        #item-window {
          position: absolute;
          width: 100%;
          height: 30px;
          bottom: 20px;
          right: 30px;
          display: flex;
          justify-content: space-between;
          pointer-events: none;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
        }

        .display-item {
          border: 2px solid rgb(129 129 129);
          border-radius: 10px;
          background: white;
          opacity: 0.8;
          margin-left: 10px;
          padding-left: 5px;
          padding-right: 5px;
          display: flex;
          align-items: center;
          pointer-events: initial;
        }

        .display-item i {
          margin-left: 10px;
          color: rgb(203, 90, 90);
          padding: 3px;
        }


        .select {
            position: relative;
            display: inline-block;
            height: 28px;
            padding: 5px;
            border: 1px solid rgb(153, 153, 153);
            cursor: pointer;
            flex: 2 1 0%;
            border-radius: 5px;
        }
    
        .select-text {
            position: absolute;
            top: 5px;
            left: 10px;
            font-size: 16px;
            padding-right: 25px;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            border-radius: 5px;
            text-overflow: ellipsis;
        }
    
        .select-arrow {
            position: absolute;
            top: 15px;
            right: 10px;
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-top: 7px solid black;
        }

        .top-template-list {
          padding-bottom: 10px;
          display: none;
          position: fixed;
          flex-direction: column;
          border: 1px solid rgb(153, 153, 153);
          border-radius: 4px;
          z-index: 1000;
          max-height: 200px;
          overflow-y: auto;
          background-color: white;
        }
        
        .top-template-item {
          display: flex;
          align-items: center;
          padding-top: 5px;
          padding-right: 10px;
          padding-left: 10px;
          color: black;
        }
  
        .top-template-item:hover {
          background-color: #f5f5f5;
        }

        .top-template-item:last-child {
          padding-bottom: 5px;
        }
        
        .drag-handle {
          cursor: move;
          margin-right: 10px;
        }
        
        .top-template-name {
          flex-grow: 1;
          color: black;
          padding-right: 5px;
          padding-left: 5px;
        }
  
        .top-template-item.dragging {
          opacity: 0.5;
          transition: opacity 0.2s;
        } 
        
        .selected-template {
          background: rgb(187 200 255);
        }

        .selected-template:hover {
          background: #aabfff;
        }
  
        .move-point{
          visibility: hidden;
          width: 90%;
          border-bottom: 2px dashed black;
          position: absolute;
          transform: translateY(2px);
        }
        
        #contextMenu{
          width: 200px;
        }
  
        .fab {
          position: absolute;
          width: 40px;
          height: 40px;
          background: rgb(255, 255, 255);
          border: 2px solid rgb(135, 135, 135);
          color: rgb(135, 135, 135);
          border-radius: 50%;
          pointer-events: initial;
        }
      
        .fab i {
          font-size: 20px;
        }

        .fab-trash-box{
          left: -7px;
        }

        .template-trash-box {
          display: none;
          position: fixed;
          border-radius: 10px;
          box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;
          flex-direction: column;
          background: rgba(0, 0, 0, 0.77);
          height: 200px;
          width: 250px;
        }

        .template-trash-box-sub-title {
          display: flex;
          justify-content: center;
        }
        
        .template-trash-box-node {
            border: 1px solid #ccc;
            padding: 0px 0px 0px 10px;
            margin: 0px 0px 5px 0px;
            background-color: #f9f9f9;
            border-radius: 5px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            padding-right: 0px;
            margin-right: 0px;
            position: relative;
            user-select: none;
        }

        .template-trash-box-delete-button{
            position: absolute;
            font-size: small;
            border-radius: 12px;
            left: 2px;
            top: 2px;
            background: white;
        }
    
        .template-trash-box-sub-title-text {
            border-bottom: 1px solid rgb(207, 207, 207);
            width: 80%;
            text-align: center;
            color: white;
        }

        .template-trash-box-panel {
            height: 100%;
            padding: 5px;
            margin: 5px;
            display: flex;
            flex-direction: column;
            background-color: rgb(255, 255, 255);
            box-sizing: border-box;
            user-select: none;
            border-width: 1px;
            border-style: solid;
            border-color: rgb(204, 204, 204);
            border-radius: 0px 0px var(--sub-margin) var(--sub-margin);
            overflow-y: auto;
        }

        .template-trash-box-node-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 5px;
        }
          
        .template-trash-box-node-title-left {
            display: flex;
            flex-direction: column;
        }
        
        .template-trash-box-node-title-right {
            display: flex;
            align-items: center;
        }

        .template-trash-box-node-delete-button {
            position: absolute;
            font-size: small;
            border-radius: 12px;
            right: 2px;
            top: 2px;
            background: white;
            border: 1px solid gray;
            color: gray;
        }
        
        .template-trash-box-label-id {
            font-size: small;
            color: #917bff;
        }

        .template-trash-box-node-label-tag-container {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            flex-wrap: nowrap;
        }

        .template-trash-box-non-trash-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
        }

        .template-trash-box-non-trush-message {
            color: #c5c5c5;
        }

        @media (max-width: 768px) {
          .title {
            font-size: 12px;
          }
          .tab {
            font-size: 12px;
          }
        }
    `;

  static get properties() {
    return {
      canUndo: { type: Boolean },
      canRedo: { type: Boolean },
      showTemplatePopup: { type: Boolean }
    };
  }

  constructor() {
    super();
    let templateDragController = new TemplateDragController(this);

    this.showTemplatePopup = false;
    this.templateRootDragElement = null;
    this.templateRootOverElement = null;

    //ドラッグ操作中
    this.isDragging = false;

    // ノードをクリックして選択した場合はtrue
    this.selfNodeClick = false;

    this.canUndo = false;
    this.canRedo = false;

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.boundHandleWindowResize = this.handleWindowResize.bind(this);

    templateSelectedItemStore.subscribe(this.callbackTemplateItemSelect.bind(this));
    templateSelectedRootStore.subscribe(this.callbackTemplateRootSelect.bind(this));
    templateJsonStore.subscribe(this.callbackTemplateJsonUpdate.bind(this));
    templateCopyItemStore.subscribe(this.callbackTemplateCopyItemUpdate.bind(this));

    // ユーザー設定ストアを購読して、AI有効・無効状態が切り替わったときにDOMツリーを再評価
    this.unsubscribeUserSetting = userSettingStore.subscribe(() => {
      this.displayDOMTree();
    });

    window.addEventListener('to-element', this.handleToElement.bind(this));
    window.addEventListener('to-element-and-select', this.handleToElementAndSelect.bind(this));
    window.addEventListener('select-element', this.handleSelectElement.bind(this));
  }

  firstUpdated() {
    //super.firstUpdated();
    requestAnimationFrame(() => {
      this.displayDOMTree();
      const fontAwasomeStyle = document.querySelector(
        "link[rel='stylesheet'][data-name='fontawesomev6']"
      );
      const fontAwasomeStyleClone = fontAwasomeStyle.cloneNode(true);
      fontAwasomeStyleClone.removeAttribute('disabled');
      this.shadowRoot.insertBefore(fontAwasomeStyleClone, this.shadowRoot.firstChild);

      this.addEventListener('click', this.handleTemplateItemDeSelect.bind(this));
      this.addEventListener('click', this.handleCloseContextMenu.bind(this));
      this.addEventListener('click', this.closeTemplateListPopup.bind(this));
      this.addEventListener('click', this.handleCloseTrashBox.bind(this));
      this.addEventListener('click', this.closeSearchSubWindow.bind(this));
      const tmp = templateJsonStore.getState();
      if (tmp && tmp.templateJson && tmp.templateJson.templates && tmp.templateJson.templates[0] && tmp.templateJson.templates[0].id) {
        if (templateJsonStore.getState().templateJson.templates[0].id) {
          const appId = templateJsonStore.getState().templateJson.templates[0].id;
          templateSelectedRootStore.dispatch(selectRoot(appId));
          templateSelectedItemStore.dispatch(selectItem(appId));
        }
      }
      this.handleWindowResize();
    });

  }

  update() {
    super.update();
    this.handleWindowResize();
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('click', this.boundHandleClickOutside);

    //ウィンドウサイズが変わった時のイベント
    window.addEventListener('resize', this.boundHandleWindowResize);

    // キーボードショートカットのリスナー登録
    this.boundHandleKeyDown = this.handleKeyDown.bind(this);
    window.addEventListener('keydown', this.boundHandleKeyDown);

    // ResizeObserverによる自身（ホスト）のサイズ監視を追加
    this._resizeObserver = new ResizeObserver(() => {
      this.handleWindowResize();
    });
    this._resizeObserver.observe(this);
  }

  disconnectedCallback() {
    window.removeEventListener('click', this.boundHandleClickOutside);

    //ウィンドウサイズが変わった時のイベント
    window.removeEventListener('resize', this.boundHandleWindowResize);

    // リスナーの解除
    window.removeEventListener('keydown', this.boundHandleKeyDown);

    // ResizeObserverの解除
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    // ストア購読解除
    if (this.unsubscribeUserSetting) {
      this.unsubscribeUserSetting();
    }

    super.disconnectedCallback();
  }

  /**
   * スターターテンプレート（骨組み）の一括適用処理
   * AIの処理と同様に Undo を一つにまとめる
   */
  async applyStarterTemplate(type) {
    const state = templateJsonStore.getState().templateJson;
    const appTemplate = state.templates[0];

    // すでに子要素がある場合は何もしない（安全装置）
    if (appTemplate.children && appTemplate.children.length > 0) {
      return;
    }

    // 自動再描画を停止し、Undoバッチを開始
    templateJsonStore.dispatch({ type: 'templateJson/setReloadOff' });

    try {
      if (type === 'navigator') {
        const homeId = "home_page";
        const detailId = "detail_page";
        const homeButtonId = v4();

        // 1. Appの直下にnavigatorを配置
        templateJsonStore.dispatch(insertAsChild({
          targetId: appTemplate.id,
          newElement: {
            tagName: 'ons-navigator', domId: 'navigator', explain: 'ナビゲーター',
            attributes: { page: `${homeId}.html` }, children: []
          }
        }));

        // 2. ホーム画面を追加
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: homeId, explain: 'ホーム画面',
            attributes: { 'template-id': `${homeId}.html` },
            children: [
              {
                tagName: 'ons-toolbar', explain: 'ツールバー', attributes: {}, children: [
                  { tagName: 'div', explain: 'left', attributes: { class: 'left' }, children: [] },
                  { tagName: 'div', explain: 'center', attributes: { class: 'center' }, text: 'ホーム', children: [] },
                  { tagName: 'div', explain: 'right', attributes: { class: 'right' }, children: [] }
                ]
              },
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              {
                tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content', style: 'padding: 20px; text-align: center;' }, children: [
                  { tagName: 'p', text: '基本の画面遷移テンプレートです。', children: [] },
                  { tagName: 'ons-button', id: homeButtonId, domId: 'push_button', text: '詳細ページへ移動', attributes: { modifier: 'large' }, children: [] }
                ]
              }
            ]
          },
          forceReload: false
        }));

        // 3. 詳細画面を追加
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: detailId, explain: '詳細画面',
            attributes: { 'template-id': `${detailId}.html` },
            children: [
              {
                tagName: 'ons-toolbar', explain: 'ツールバー', attributes: {}, children: [
                  {
                    tagName: 'div', explain: 'left', attributes: { class: 'left' }, children: [
                      { tagName: 'ons-back-button', explain: '戻るボタン', text: '戻る', children: [] }
                    ]
                  },
                  { tagName: 'div', explain: 'center', attributes: { class: 'center' }, text: '詳細', children: [] },
                  { tagName: 'div', explain: 'right', attributes: { class: 'right' }, children: [] }
                ]
              },
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              {
                tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content', style: 'padding: 20px;' }, children: [
                  { tagName: 'p', text: '左上の「戻る」ボタンでホームに戻れます。', attributes: { style: 'text-align: center;' }, children: [] }
                ]
              }
            ]
          },
          forceReload: false
        }));

        // 4. ページ遷移用のスクリプトを登録
        scriptItemStore.dispatch(addNewScript({
          scriptName: 'pushDetail',
          scriptType: 'function',
          scriptContent: [
            '/**',
            ' * 詳細ページへ遷移します。',
            ' */',
            'function pushDetail() {',
            "    const navi = document.querySelector('ons-navigator');",
            '    if (navi) {',
            "        navi.pushPage('detail_page.html');",
            '    }',
            '}'
          ],
          comment: '詳細ページへ移動する関数'
        }));

        // 5. ボタンへ click イベントを設定してスクリプトを紐付け
        const eventName = 'click';
        const buttonTagName = 'ons-button';
        const eventItemsState = eventItemStore.getState().eventItems;
        let buttonTagDef = eventItemsState.items.find(item => item.tagName === buttonTagName);

        if (!buttonTagDef) {
          eventItemStore.dispatch(addNewEventTag({ tagName: buttonTagName }));
          buttonTagDef = eventItemStore.getState().eventItems.items.find(item => item.tagName === buttonTagName);
        }

        const hasButtonEvent = buttonTagDef && buttonTagDef.events.some(e => Object.keys(e)[0] === eventName);
        if (!hasButtonEvent) {
          eventItemStore.dispatch(addEventToExistingTag({
            tagName: buttonTagName,
            event: {
              [eventName]: {
                listenerTarget: 'element',
                scripts: [],
                comment: '要素をクリックした時'
              }
            }
          }));
        }

        eventItemStore.dispatch(addScriptToExistingTag({
          tagName: buttonTagName,
          templateId: homeButtonId,
          eventName: eventName,
          scriptName: 'pushDetail'
        }));
      } else if (type === 'tabbar') {
        const tab1Id = "home_page";
        const tab2Id = "settings_page";

        // 1. Appの直下に直接「ons-tabbar」を配置
        templateJsonStore.dispatch(insertAsChild({
          targetId: appTemplate.id,
          newElement: {
            tagName: 'ons-tabbar', domId: 'tabbar', explain: 'タブバー', attributes: { position: 'bottom' },
            children: [
              { tagName: 'ons-tab', explain: 'ホームタブ', attributes: { page: `${tab1Id}.html`, label: 'ホーム', icon: 'fa-house', active: true }, children: [] },
              { tagName: 'ons-tab', explain: '設定タブ', attributes: { page: `${tab2Id}.html`, label: '設定', icon: 'fa-gear' }, children: [] }
            ]
          }
        }));

        // 2. ホーム画面
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: tab1Id, explain: 'ホーム画面',
            attributes: { 'template-id': `${tab1Id}.html` },
            children: [
              {
                tagName: 'ons-toolbar', explain: 'ツールバー', attributes: {}, children: [
                  { tagName: 'div', explain: 'left', attributes: { class: 'left' }, children: [] },
                  { tagName: 'div', explain: 'center', attributes: { class: 'center' }, text: 'ホーム', children: [] },
                  { tagName: 'div', explain: 'right', attributes: { class: 'right' }, children: [] }
                ]
              },
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              { tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content', style: 'padding: 20px;' }, children: [{ tagName: 'p', text: 'ホーム画面のコンテンツ', children: [] }] }
            ]
          }, forceReload: false
        }));

        // 3. 設定画面
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: tab2Id, explain: '設定画面',
            attributes: { 'template-id': `${tab2Id}.html` },
            children: [
              {
                tagName: 'ons-toolbar', explain: 'ツールバー', attributes: {}, children: [
                  { tagName: 'div', explain: 'left', attributes: { class: 'left' }, children: [] },
                  { tagName: 'div', explain: 'center', attributes: { class: 'center' }, text: '設定', children: [] },
                  { tagName: 'div', explain: 'right', attributes: { class: 'right' }, children: [] }
                ]
              },
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              { tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content', style: 'padding: 20px;' }, children: [{ tagName: 'p', text: '設定画面のコンテンツ', children: [] }] }
            ]
          }, forceReload: false
        }));

      } else if (type === 'splitter') {
        const menuId = "menu_page";
        const homeId = "home_page";
        const settingsId = "settings_page";

        // 各種動的イベント紐付けに必要なIDを取得
        const mainToolbarButtonId = v4();
        const settingsToolbarButtonId = v4();
        const menuHomeItemId = v4();
        const menuSettingsItemId = v4();

        // 1. Appの直下にsplitterを配置
        templateJsonStore.dispatch(insertAsChild({
          targetId: appTemplate.id,
          newElement: {
            tagName: 'ons-splitter', domId: 'splitter', explain: 'スプリッター', attributes: {},
            children: [
              { tagName: 'ons-splitter-side', domId: 'menu', explain: 'サイドメニュー枠', attributes: { side: 'left', width: '220px', collapse: 'collapse', swipeable: true, page: `${menuId}.html` }, children: [] },
              { tagName: 'ons-splitter-content', domId: 'content', explain: 'メイン画面枠', attributes: { page: `${homeId}.html` }, children: [] }
            ]
          }
        }));

        // 2. サイドメニュー画面
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: menuId, explain: 'サイドメニュー画面',
            attributes: { 'template-id': `${menuId}.html` },
            children: [
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              {
                tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content' }, children: [
                  {
                    tagName: 'ons-list', explain: 'リスト', attributes: {}, children: [
                      { tagName: 'ons-list-header', text: 'メニュー', children: [] },
                      {
                        tagName: 'ons-list-item',
                        id: menuHomeItemId,
                        domId: 'menu_home_item',
                        explain: 'ホーム項目',
                        text: 'ホーム',
                        attributes: { modifier: 'tappable' },
                        children: []
                      },
                      {
                        tagName: 'ons-list-item',
                        id: menuSettingsItemId,
                        domId: 'menu_settings_item',
                        explain: '設定項目',
                        text: '設定',
                        attributes: { modifier: 'tappable' },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }, forceReload: false
        }));

        // 3. ホーム画面
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: homeId, explain: 'ホーム画面',
            attributes: { 'template-id': `${homeId}.html` },
            children: [
              {
                tagName: 'ons-toolbar', explain: 'ツールバー', attributes: {}, children: [
                  {
                    tagName: 'div', explain: 'left', attributes: { class: 'left' }, children: [
                      {
                        tagName: 'ons-toolbar-button',
                        id: mainToolbarButtonId,
                        domId: 'menu_button',
                        explain: 'メニュー表示ボタン',
                        attributes: {},
                        children: [{ tagName: 'ons-icon', attributes: { icon: 'fa-bars' }, children: [] }]
                      }
                    ]
                  },
                  { tagName: 'div', explain: 'center', attributes: { class: 'center' }, text: 'ホーム', children: [] },
                  { tagName: 'div', explain: 'right', attributes: { class: 'right' }, children: [] }
                ]
              },
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              { tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content', style: 'padding: 20px;' }, children: [{ tagName: 'p', text: 'ホーム画面のコンテンツ', children: [] }] }
            ]
          }, forceReload: false
        }));

        // 4. 新規設定画面
        templateJsonStore.dispatch(addTemplate({
          newTemplate: {
            tagName: 'ons-page', type: 'page', domId: settingsId, explain: '設定画面',
            attributes: { 'template-id': `${settingsId}.html` },
            children: [
              {
                tagName: 'ons-toolbar', explain: 'ツールバー', attributes: {}, children: [
                  {
                    tagName: 'div', explain: 'left', attributes: { class: 'left' }, children: [
                      {
                        tagName: 'ons-toolbar-button',
                        id: settingsToolbarButtonId,
                        domId: 'settings_menu_button',
                        explain: 'メニュー表示ボタン',
                        attributes: {},
                        children: [{ tagName: 'ons-icon', attributes: { icon: 'fa-bars' }, children: [] }]
                      }
                    ]
                  },
                  { tagName: 'div', explain: 'center', attributes: { class: 'center' }, text: '設定', children: [] },
                  { tagName: 'div', explain: 'right', attributes: { class: 'right' }, children: [] }
                ]
              },
              { tagName: 'div', explain: 'バックグラウンド', attributes: { class: 'page__background' }, children: [] },
              { tagName: 'div', explain: 'コンテンツ', attributes: { class: 'page__content', style: 'padding: 20px;' }, children: [{ tagName: 'p', text: '設定画面のコンテンツ', children: [] }] }
            ]
          }, forceReload: false
        }));

        // 5. 各種遷移・メニュー制御スクリプトを登録
        scriptItemStore.dispatch(addNewScript({
          scriptName: 'openMenu',
          scriptType: 'function',
          scriptContent: [
            '/**',
            ' * サイドメニューを開きます。',
            ' */',
            'function openMenu() {',
            "    const menu = document.getElementById('menu');",
            '    if (menu) {',
            '        menu.open();',
            '    }',
            '}'
          ],
          comment: 'サイドメニューを開く関数'
        }));

        scriptItemStore.dispatch(addNewScript({
          scriptName: 'gotoHome',
          scriptType: 'function',
          scriptContent: [
            '/**',
            ' * ホーム画面へ遷移します。',
            ' */',
            'function gotoHome() {',
            "    const content = document.getElementById('content');",
            "    const menu = document.getElementById('menu');",
            "    if (content) {",
            "        content.load('home_page.html');",
            "    }",
            "    if (menu) {",
            "        menu.close();",
            "    }",
            '}'
          ],
          comment: 'ホーム画面に切り替える関数'
        }));

        scriptItemStore.dispatch(addNewScript({
          scriptName: 'gotoSettings',
          scriptType: 'function',
          scriptContent: [
            '/**',
            ' * 設定画面へ遷移します。',
            ' */',
            'function gotoSettings() {',
            "    const content = document.getElementById('content');",
            "    const menu = document.getElementById('menu');",
            "    if (content) {",
            "        content.load('settings_page.html');",
            "    }",
            "    if (menu) {",
            "        menu.close();",
            "    }",
            '}'
          ],
          comment: '設定画面に切り替える関数'
        }));

        // 6. 各種イベントリスナー定義と、スクリプトのバインド（紐付け）
        const eventName = 'click';

        // 6-1. ons-toolbar-button に対する click イベント設定・バインド
        const buttonTagName = 'ons-toolbar-button';
        const eventItemsState = eventItemStore.getState().eventItems;
        let buttonTagDef = eventItemsState.items.find(item => item.tagName === buttonTagName);
        if (!buttonTagDef) {
          eventItemStore.dispatch(addNewEventTag({ tagName: buttonTagName }));
          buttonTagDef = eventItemStore.getState().eventItems.items.find(item => item.tagName === buttonTagName);
        }
        const hasButtonEvent = buttonTagDef && buttonTagDef.events.some(e => Object.keys(e)[0] === eventName);
        if (!hasButtonEvent) {
          eventItemStore.dispatch(addEventToExistingTag({
            tagName: buttonTagName,
            event: {
              [eventName]: {
                listenerTarget: 'element',
                scripts: [],
                comment: '要素をクリックした時'
              }
            }
          }));
        }
        // ホーム画面のボタンに openMenu を紐付ける
        eventItemStore.dispatch(addScriptToExistingTag({
          tagName: buttonTagName,
          templateId: mainToolbarButtonId,
          eventName: eventName,
          scriptName: 'openMenu'
        }));
        // 設定画面のボタンに openMenu を紐付ける
        eventItemStore.dispatch(addScriptToExistingTag({
          tagName: buttonTagName,
          templateId: settingsToolbarButtonId,
          eventName: eventName,
          scriptName: 'openMenu'
        }));

        // 6-2. ons-list-item に対する click イベント設定・バインド
        const itemTagName = 'ons-list-item';
        let itemTagDef = eventItemsState.items.find(item => item.tagName === itemTagName);
        if (!itemTagDef) {
          eventItemStore.dispatch(addNewEventTag({ tagName: itemTagName }));
          itemTagDef = eventItemsState.items.find(item => item.tagName === itemTagName);
        }
        const hasListItemEvent = itemTagDef && itemTagDef.events.some(e => Object.keys(e)[0] === eventName);
        if (!hasListItemEvent) {
          eventItemStore.dispatch(addEventToExistingTag({
            tagName: itemTagName,
            event: {
              [eventName]: {
                listenerTarget: 'element',
                scripts: [],
                comment: '要素をクリックした時'
              }
            }
          }));
        }
        // メニュー画面の「ホーム」項目に gotoHome を紐付ける
        eventItemStore.dispatch(addScriptToExistingTag({
          tagName: itemTagName,
          templateId: menuHomeItemId,
          eventName: eventName,
          scriptName: 'gotoHome'
        }));
        // メニュー画面の「設定」項目に gotoSettings を紐付ける
        eventItemStore.dispatch(addScriptToExistingTag({
          tagName: itemTagName,
          templateId: menuSettingsItemId,
          eventName: eventName,
          scriptName: 'gotoSettings'
        }));
      }
    } finally {
      // 最後に自動再描画をオンにして、Undoバッチを終了
      templateJsonStore.dispatch({ type: 'templateJson/setReloadOn' });
      // アプリルートを選択状態に戻す
      templateSelectedRootStore.dispatch(selectRoot(appTemplate.id));
      templateSelectedItemStore.dispatch(selectItem(appTemplate.id));
    }
  }

  /**
   * HTMLタグを追加する際、プリセットの選択肢と手入力を備えたダイアログを表示し、
   * 決定されたタグ名を非同期で返します。
   */
  async showHtmlTagSelectDialog() {
    const dialog = this.shadowRoot.querySelector('#html-tag-select-dialog');
    const input = this.shadowRoot.querySelector('#custom-tag-input');
    input.value = '';

    // プリセットボタンがタップされた際、値をインプットにセットし、OKボタンをクリックして自動決定します
    this._selectPresetTag = (tag) => {
      input.value = tag;
      const okBtn = dialog.querySelector('[slot="ok-slot"]');
      if (okBtn) okBtn.click();
    };

    // カスタム入力欄でのEnterキー押下時にも、自動でOKボタンをクリックして決定します
    this._handleCustomTagKeydown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const okBtn = dialog.querySelector('[slot="ok-slot"]');
        if (okBtn) okBtn.click();
      }
    };

    const confirmed = await dialog.show();
    if (confirmed) {
      const tagName = input.value.trim().toLowerCase();
      return tagName || null;
    }
    return null;
  }

  /**
   * キーボードイベントのハンドラ
   * Undo/Redoのショートカットやトップテンプレートのキーボード操作を検知します。
   */
  handleKeyDown(event) {
    // AIエージェントやAIコーダーのウィンドウが開いているときはキャンバスのUndo/Redoを無効化
    const appContainer = document.querySelector('app-container');
    if (appContainer && appContainer.shadowRoot) {
      const agentWindow = appContainer.shadowRoot.querySelector('agent-chat-window');
      if (agentWindow && agentWindow.style.display === 'block') {
        return;
      }
      const aiCoderWindow = appContainer.shadowRoot.querySelector('ai-coder-window');
      if (aiCoderWindow && aiCoderWindow.style.display === 'block') {
        return;
      }
    }

    if (this.showTemplatePopup) {
      const templates = templateJsonStore.getState().templateJson.templates;
      const currentSelectedId = templateSelectedRootStore.getState().templateSelectedRoot.targetId;
      let currentIndex = templates.findIndex(t => t.id === currentSelectedId);
      if (currentIndex === -1) currentIndex = 0;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        const nextIndex = (currentIndex + 1) % templates.length;
        const selectedId = templates[nextIndex].id;

        templateSelectedRootStore.dispatch(selectRoot(selectedId));
        templateSelectedItemStore.dispatch(selectItem(selectedId));

        this.requestUpdate();
        this._scrollToSelectedTemplate();
        return;
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        const nextIndex = (currentIndex - 1 + templates.length) % templates.length;
        const selectedId = templates[nextIndex].id;

        templateSelectedRootStore.dispatch(selectRoot(selectedId));
        templateSelectedItemStore.dispatch(selectItem(selectedId));

        this.requestUpdate();
        this._scrollToSelectedTemplate();
        return;
      } else if (event.key === 'Enter') {
        event.preventDefault();
        this.closeTemplateListPopup(event);
        return;
      } else if (event.key === 'Escape') {
        event.preventDefault();
        this.closeTemplateListPopup(event);
        return;
      }
    }

    // event.composedPath() を使って、Shadow DOMの奥深くまで含めたイベントの発生元パスを取得
    const path = event.composedPath();

    // 入力フォームやコードエディタにフォーカスがある場合は、ブラウザやエディタ側の挙動を優先するためスキップ
    const isInputActive = path.some(el => {
      if (!el || !el.tagName) return false;
      const tag = el.tagName.toUpperCase();
      return tag === 'INPUT' ||
        tag === 'TEXTAREA' ||
        el.isContentEditable ||
        (el.classList && el.classList.contains('monaco-editor')) ||
        tag === 'SCRIPT-CONTAINER' ||
        tag === 'PROPERTY-CONTAINER' ||
        tag === 'TOOL-BOX-ITEM-EDITOR' ||
        tag === 'APPSETTING-CONTAINER' ||
        tag === 'TEST-SCENARIO-EDITOR';
    });

    if (isInputActive) return;

    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const cmdOrCtrl = isMac ? event.metaKey : event.ctrlKey;

    if (cmdOrCtrl && event.key.toLowerCase() === 'z') {
      event.preventDefault();
      if (event.shiftKey) {
        // Redo (Ctrl + Shift + Z / Cmd + Shift + Z)
        templateHistoryManager.redo(templateJsonStore);
      } else {
        // Undo (Ctrl + Z / Cmd + Z)
        templateHistoryManager.undo(templateJsonStore);
      }
    } else if (cmdOrCtrl && event.key.toLowerCase() === 'y') {
      // Redo (Ctrl + Y)
      event.preventDefault();
      templateHistoryManager.redo(templateJsonStore);
    }
  }

  handleToElement(e) {
    const toElementData = JSON.parse(e.detail);
    const topTemplateId = toElementData.topTemplateId;
    const targetTemplateId = toElementData.targetTemplateId;
    const expandNode = toElementData.expandNode;
    //templateSelectedRootStore.dispatch(selectRoot(topTemplateId));
    //templateSelectedItemStore.dispatch(selectItem(targetTemplateId));

    let currentId = targetTemplateId;

    if (expandNode) {
      while (currentId && currentId !== topTemplateId) {
        const parent = findParentById(templateJsonStore.getState().templateJson, currentId);
        if (!parent) break;
        templateJsonStore.dispatch(updateExpand({ id: parent.id, newExpand: true }));
        currentId = parent.id;
      }
    }
    // requestAnimationFrame(() => {
    //   const element = this.shadowRoot.querySelector('[data-node-id="' + toElementData.targetTemplateId + '"]');

    //   // 要素が見つかった場合、その要素までスムーズにスクロールする
    //   if (element) {
    //     element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //   }
    // });

    requestAnimationFrame(() => {

      let element = this.shadowRoot.querySelector('.node-select, .node-select-parent');
      if (!element) {
        element = this.shadowRoot.querySelector('[data-node-id="' + toElementData.targetTemplateId + '"]');
      }


      // 要素が見つかった場合、その要素までスムーズにスクロールする
      if (element) {
        const isPage = element.dataset.nodeType === 'ons-page' || element.dataset.nodeType === 'page';
        element.scrollIntoView({
          behavior: 'smooth',
          block: isPage ? 'start' : 'center'
        });
      }
    });
  }

  handleToElementAndSelect(e) {
    const toElementData = JSON.parse(e.detail);
    const topTemplateId = toElementData.topTemplateId;
    const targetTemplateId = toElementData.targetTemplateId;
    const expandNode = toElementData.expandNode;
    templateSelectedRootStore.dispatch(selectRoot(topTemplateId));
    templateSelectedItemStore.dispatch(selectItem(targetTemplateId));

    let currentId = targetTemplateId;

    if (expandNode) {
      while (currentId && currentId !== topTemplateId) {
        const parent = findParentById(templateJsonStore.getState().templateJson, currentId);
        if (!parent) break;
        templateJsonStore.dispatch(updateExpand({ id: parent.id, newExpand: true }));
        currentId = parent.id;
      }
    }

    requestAnimationFrame(() => {

      let element = this.shadowRoot.querySelector('.node-select, .node-select-parent');
      if (!element) {
        element = this.shadowRoot.querySelector('[data-node-id="' + toElementData.targetTemplateId + '"]');
      }

      // 要素が見つかった場合、その要素までスムーズにスクロールする
      if (element) {
        const isPage = element.dataset.nodeType === 'ons-page' || element.dataset.nodeType === 'page';
        element.scrollIntoView({
          behavior: 'smooth',
          block: isPage ? 'start' : 'center'
        });
      }
    });
  }

  /**
   * select-elementイベントを受けて、ノードを選択状態にする
   * @param {*} event 
   */
  handleSelectElement(event) {
    const selectElementData = JSON.parse(event.detail);
    const topTemplateId = selectElementData.topTemplateId;
    const targetTemplateId = selectElementData.targetTemplateId;
    //templateSelectedRootStore.dispatch(selectRoot(topTemplateId));
    templateSelectedItemStore.dispatch(selectItem(targetTemplateId));
    this.selfNodeClick = true;
  }
  // /**
  //  * テンプレートのポップアップのトグル
  //  * 
  //  * @param {*} event 
  //  */
  // toggleTemplatePopup(event) {
  //   event.stopPropagation();
  //   this.handleCloseContextMenu(event);
  //   if (this.showTemplatePopup) {
  //     this.closeTemplatePopup();
  //   } else {
  //     this.showTemplatePopup = true;
  //   }
  //   this.requestUpdate();
  // }

  /**
   * 選択されているテンプレートへスクロールする
   */
  _scrollToSelectedTemplate() {
    requestAnimationFrame(() => {
      const list = this.shadowRoot.getElementById('top-template-list');
      if (!list) return;
      const selectedItem = list.querySelector('.selected-template');
      if (selectedItem) {
        selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  /**
  * テンプレートリストのオープン
  * 
  * @param {*} event 
  */
  openTemplateListPopup(event) {
    //event.stopPropagation();
    this.handleCloseContextMenu(event);
    this.handleCloseTrashBox(event);
    this.closeSearchSubWindow(event);

    if (this.showTemplatePopup) {
      this.showTemplatePopup = false;
      this.requestUpdate();
      return;
    }
    this.showTemplatePopup = true;

    requestAnimationFrame(() => {
      //selectの要素を探す
      const select = this.shadowRoot.querySelector(".select");
      const selectRect = select.getBoundingClientRect();
      //id=top-template-listの要素を探す
      const topTemplateList = this.shadowRoot.getElementById("top-template-list");
      //top-template-listのtopをselectのbottomにする
      topTemplateList.style.top = selectRect.bottom + "px";

      // 最初に選択されているアイテムにスクロールしておく
      this._scrollToSelectedTemplate();
    })

    this.requestUpdate();
  }

  /**
  * テンプレートリストのクローズ
  * 
  * @param {*} event 
  */
  closeTemplateListPopup(event) {
    //event.stopPropagation();
    this.showTemplatePopup = false;
    this.requestUpdate();
  }

  /**
   * テンプレートを閉じる
   * @returns 
   */
  closeTemplatePopup() {
    if (this.showTemplatePopup === false) return;
    this.showTemplatePopup = false;
    this.requestUpdate();
  }

  showSearchSubWindow(e) {
    this.handleClickOutside(e);

    const subWindow = this.shadowRoot.querySelector("template-search-sub-window");
    subWindow.show();
    e.stopPropagation();
  }

  closeSearchSubWindow() {
    const subWindow = this.shadowRoot.querySelector("template-search-sub-window");
    subWindow.hide();
  }
  /**
   * ウィンドウサイズが変わった時のイベント
   */
  handleWindowResize() {
    const itemWindow = this.shadowRoot.getElementById("item-window");
    if (itemWindow) {
      const parent = itemWindow.parentNode //this.shadowRoot.host;

      // fabの位置とサイズを取得
      const itemWindowRect = itemWindow.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();

      itemWindow.style.top = parentRect.top + parentRect.height - 40 + "px"
      const left = parentRect.x + 4;
      const right = parentRect.x + parentRect.width;
      itemWindow.style.left = left + "px";

      const offsetWidth = parent.offsetWidth;
      const clientWidth = parent.clientWidth;
      const scrollBarWidth = offsetWidth - clientWidth;

      itemWindow.style.width = parentRect.width - scrollBarWidth - 15 + "px";
    }
  }

  handleClickOutside(event) {
    if (window.isToolboxItemDrop) {
      // ツールボックスアイテムからドロップしたときにトップテンプレートリストが閉じられることを回避する
      window.isToolboxItemDrop = false;
    } else {
      if (!this.contains(event.target)) {
        this.handleCloseContextMenu(event);
      }

      this.closeTemplateListPopup(event);
      this.cancelDeleteReserve();
      this.handleCloseTrashBox(event);
      this.closeSearchSubWindow();
    }
  }

  /**
   * 削除予約をリセット
   */
  cancelDeleteReserve() {
    const nodes = this.shadowRoot.querySelectorAll('.node[data-delete-reserve="true"]');
    for (const node of nodes) {
      node.removeAttribute('data-delete-reserve');
      const clearIcon = node.querySelector('.clear-icon i');
      clearIcon.classList.add('fa-regular', 'fa-trash-can');
      clearIcon.classList.remove('fa-solid', 'fa-check');
    }
  }

  // ドロップダウンリストを生成する関数
  populateDropdown() {
    const dropdownList = this.shadowRoot.getElementById('dropdown-list');
    const templateJson = templateJsonStore.getState().templateJson;

    // 子要素の数だけループ
    for (let i = dropdownList.options.length - 1; i >= 0; i--) {
      // removeメソッドで子要素を削除
      dropdownList.remove(i);
    }

    // 子要素を追加
    templateJson.templates.forEach(template => {
      const option = document.createElement('option');
      option.value = template.id;
      option.textContent = template.explain;
      dropdownList.appendChild(option);
    });
  }


  // 選択したアイテムのDOMツリーを表示する関数
  displayDOMTree() {
    const domTreeContainer = this.shadowRoot.getElementById('dom-tree');

    let selectedId = templateSelectedRootStore.getState().templateSelectedRoot.targetId;
    if (!selectedId) {
      const tmp = templateJsonStore.getState();
      if (tmp.templateJson && tmp.templateJson.templates && tmp.templateJson.templates[0] && tmp.templateJson.templates[0].id) {
        selectedId = tmp.templateJson.templates[0].id;
      }
    }

    // リストを初期化
    domTreeContainer.innerHTML = '';
    // 選択したidに対応するテンプレートを検索
    const templateJson = templateJsonStore.getState().templateJson;
    const selectedTemplate = selectedId === null ? templateJson.templates[0] : templateJson.templates.find(template => template.id === selectedId);

    if (selectedTemplate) {
      // DOMツリーを再帰的に構築
      const rootNode = this.createNode(selectedTemplate);
      domTreeContainer.appendChild(rootNode);

      if (selectedTemplate.type === 'app' && (!selectedTemplate.children || selectedTemplate.children.length === 0)) {
        // AI機能の有効状態をストアから取得
        const aiCodingEnabled = userSettingStore.getState().userSetting.aiCodingEnabled;

        const emptyState = document.createElement('div');
        emptyState.className = 'empty-state-container';
        emptyState.innerHTML = `
          <div class="empty-state-title">アプリの骨組みを作成</div>
          <p class="empty-state-desc">ここから作りたいアプリの形を選んでください。</p>
          <div class="empty-state-btn" data-type="navigator"><i class="fa-solid fa-mobile-screen"></i> 基本の画面遷移</div>
          <div class="empty-state-btn" data-type="tabbar"><i class="fa-solid fa-window-restore"></i> タブメニュー</div>
          <div class="empty-state-btn" data-type="splitter"><i class="fa-solid fa-bars"></i> サイドメニュー</div>
          
          <!-- aiCodingEnabled が真の場合のみボタンを描画する -->
          ${aiCodingEnabled ? `<div class="empty-state-btn ai-btn" data-type="ai"><i class="fa-solid fa-wand-magic-sparkles"></i> AIに作ってもらう</div>` : ''}
        `;

        const btns = emptyState.querySelectorAll('.empty-state-btn');
        btns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const type = btn.getAttribute('data-type');
            if (type === 'ai') {
              this.dispatchEvent(new CustomEvent('open-ai-agent-window', { bubbles: true, composed: true }));
            } else {
              this.applyStarterTemplate(type);
            }
          });
        });

        domTreeContainer.appendChild(emptyState);
      }
    }

    //  展開と縮小
    const parentNodes = this.shadowRoot.querySelectorAll('.node');
    for (let parentNode of parentNodes) {
      const icon = parentNode.querySelector('.expand-item');
      let expand = JSON.parse(parentNode.dataset.expand);
      expand = JSON.parse(expand);
      if (expand) {
        const childNodes = parentNode.querySelectorAll('.node');
        for (const childNode of childNodes) {
          childNode.style.display = "block";
        }
        icon.classList.add("fa-caret-down");
        icon.classList.remove("fa-caret-right");
      } else {
        const childNodes = parentNode.querySelectorAll('.node');
        for (const childNode of childNodes) {
          childNode.style.display = "none";
        }
        icon.classList.remove("fa-caret-down");
        icon.classList.add("fa-caret-right");
      }
    }

    // 選択しているアイテムを取得
    this.callbackTemplateItemSelect();

    this.requestUpdate();
  }

  // ノードを再帰的に作成する関数
  createNode(nodeData) {
    if (nodeData == undefined) return null;
    // テンプレートを取得する
    const template = this.shadowRoot.getElementById('layout-template');
    // テンプレートからノードを作成する
    const node = template.content.cloneNode(true).querySelector('.node');
    node.addEventListener('click', this.handleTemplateItemSelect.bind(this));

    // モバイル長押し時のコンテキストメニューを抑制
    node.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
    node.style.setProperty('-webkit-touch-callout', 'none');

    // ノードのデータを設定する
    node.querySelector('.label-tag-name').textContent = nodeData.explain &&
      (nodeData.explain !== undefined || nodeData.explain !== null || nodeData.explain !== '') ? '' : nodeData.tagName;

    let explain = nodeData.explain &&
      (nodeData.explain !== undefined || nodeData.explain !== null || nodeData.explain !== '') ? nodeData.explain : '';

    node.querySelector('.label-explain').textContent = explain;

    node.querySelector('.label-id').textContent = 'id:' + nodeData.domId;
    node.setAttribute('data-node-id', nodeData.id);
    node.setAttribute('data-node-dom-id', nodeData.domId);
    node.setAttribute('data-node-explain', explain);

    // 展開と縮小
    let expand = nodeData.expand;
    expand = (expand !== undefined && expand !== null) ? expand : true;
    expand = JSON.parse(expand);
    node.setAttribute('data-expand', (nodeData.expand !== undefined && nodeData.expand !== null) ? nodeData.expand : true);

    if (nodeData.type) {
      node.setAttribute('data-node-type', nodeData.type);
    } else {
      node.setAttribute('data-node-type', nodeData.tagName);
    }

    // クリアアイコン
    const clearIcon = node.querySelector('.clear-icon');
    // コピーアイコン
    const copyIcon = node.querySelector('.copy-icon');

    if (node.dataset.nodeType === 'app') {
      clearIcon.style.display = 'none';
      copyIcon.style.display = 'none';
    }

    // クリアアイコンに削除イベントを設定
    clearIcon.addEventListener('click', this.handleElementDelete.bind(this));

    // コピーアイコンにコピーイベントを設定
    copyIcon.addEventListener('click', this.handleElementCopy.bind(this));


    // Expandイベントを設定
    node.querySelector('.expand-item').addEventListener('click', this.handleExpandAndCollapsed.bind(this));


    if ('type' in nodeData && nodeData.type === 'page') {
      const pageContent = document.createElement('div');
    }

    if (nodeData.children.length > 0) {
      nodeData.children.forEach(child => {
        node.appendChild(this.createNode(child));

        // 下部に追加ポイントを設定
        const lastAddPoint = document.createElement('div');
        lastAddPoint.classList.add('node-add-point');

        const addPointTooltip = document.createElement('insert-point-tooltip');
        lastAddPoint.appendChild(addPointTooltip);
        addPointTooltip.targetElement = node;

        node.appendChild(lastAddPoint);
      });
    }

    //node-add-point配下のinsert-point-tooltipにnode設定する
    const addPointTooltip = node.querySelector('.node-add-point insert-point-tooltip');
    addPointTooltip.targetElement = node;

    return node;
  }

  handleTemplateItemSelect(event) {

    event.preventDefault();

    // ノードがクリックされたことを保持するフラグ
    this.selfNodeClick = true;

    this.handleCloseContextMenu(event);
    this.closeTemplateListPopup(event);
    this.handleCloseTrashBox(event);
    this.closeSearchSubWindow(event);
    const selectId = event.currentTarget.dataset.nodeId;
    if (templateSelectedItemStore.getState().templateSelectedItem.id !== selectId) {
      templateSelectedItemStore.dispatch(selectItem(selectId));
    }

    this.cancelDeleteReserve();
  }

  findSiblingAbove(element, y) {
    var children = element.children;

    for (var i = children.length - 1; i >= 0; i--) {
      var rect = children[i].getBoundingClientRect();

      if (rect.bottom < y && children[i] !== element) {
        return children[i];
      }
    }

    return null;
  }

  handleTemplateItemDeSelect(event) {
    event.stopPropagation();

    // appを設定状態にする
    if (templateSelectedItemStore.getState().templateSelectedItem.id !== null &&
      templateSelectedItemStore.getState().templateSelectedItem.id !== templateJsonStore.getState().templateJson.templates[0].id) {
      templateSelectedItemStore.dispatch(deselectItem());
    }
  }

  /**
   * Templateのルートを選択したときのコールバック
   */
  callbackTemplateRootSelect(event) {
    this.displayDOMTree();
    this.selfNodeClick = true;
  }

  /**
   * Templateのアイテムを選択・解除したときのコールバック
   */
  callbackTemplateItemSelect(event) {
    let nodes = this.shadowRoot.querySelectorAll('.node');
    nodes.forEach((node) => {
      node.classList.remove('node-select');
      node.classList.remove('node-select-parent');
    });

    //コピー＆ペーストのアイコンを設定
    if (templateCopyItemStore.getState().templateCopyItem.id) {
      this.changePasteIcon();
    } else {
      this.changeCopyIcon();
    }

    const selectedId = templateSelectedItemStore.getState().templateSelectedItem.id;
    if (selectedId !== null) {
      let element = this.shadowRoot.querySelector('.node[data-node-id="' + selectedId + '"]');
      if (element) {
        element.classList.add('node-select');

        // 親に破線を表示
        let parentElement = element.parentElement;

        while (parentElement) {
          const isCollapsed = parentElement.dataset.expand !== undefined && !JSON.parse(parentElement.dataset.expand);
          if (isCollapsed) {
            parentElement.classList.add('node-select-parent');
          }
          parentElement = parentElement.parentElement;
        }
      }
    }

    // ノードクリックでこのコールバックが呼ばれたフラグをリセット
    this.selfNodeClick = false;

  }

  callbackTemplateJsonUpdate() {
    this.canUndo = templateHistoryManager.past.length > 0;
    this.canRedo = templateHistoryManager.future.length > 0;

    if (!templateSelectedRootStore.getState().templateSelectedRoot.targetId) {
      const appId = templateJsonStore.getState().templateJson.templates[0].id;
      templateSelectedRootStore.dispatch(selectRoot(appId));
      templateSelectedItemStore.dispatch(selectItem(appId));
    }

    this.displayDOMTree();
  }

  /**
   * コピー＆ペーストストアのコールバック
   */
  callbackTemplateCopyItemUpdate() {
    this.requestUpdate();
  }

  // /**
  //  * // サーバーからの初期データの読み込み
  //  */
  // callbackEditorData() {
  //   templateJsonStore.dispatch(loadTemplateJson(editorDataStore.getState().templateItems));
  // }

  /**
   * 削除イベント
   * @param {*} event 
   * @returns 
   */
  handleElementDelete(event) {
    event.stopPropagation();
    const deleteTarget = event.currentTarget.closest('.node');
    if ((deleteTarget.parentElement.id === "dom-tree") && (deleteTarget.dataset.nodeType === "app")) {
      alertStore.dispatch(setAlert('アプリケーションは削除できません'));
      return;
    }

    if (deleteTarget.dataset.deleteReserve) {
      if ((deleteTarget.parentElement.id === "dom-tree") && (deleteTarget.dataset.nodeType !== "app")) {
        //if (!confirm('本当に削除しますか？')) return;
        templateSelectedRootStore.dispatch(selectRoot(templateJsonStore.getState().templateJson.templates[0].id));
      }

      const topElement = findElementById(templateJsonStore.getState().templateJson, deleteTarget.dataset.nodeId);
      //eventItemStore.dispatch(deleteAllEventScript({ 'templateId': deleteTarget.dataset.nodeId }));
      templateJsonStore.dispatch(moveToTrashbox({ 'targetId': deleteTarget.dataset.nodeId }));
      templateSelectedItemStore.dispatch(deselectItem());


      const clearIcon = deleteTarget.querySelector('.clear-icon i');
      clearIcon.classList.add('fa-regular', 'fa-trash-can');
      clearIcon.classList.remove('fa-solid', 'fa-check');

      // コピー準備中のアイテムを削除したら、コピー準備も解除
      if (deleteTarget.dataset.nodeId === templateCopyItemStore.getState().templateCopyItem.id) {
        templateCopyItemStore.dispatch(deselectCopyItem());
      }
    } else {
      const clearIcon = deleteTarget.querySelector('.clear-icon i');
      clearIcon.classList.add('fa-regular', 'fa-trash-can');
      clearIcon.classList.remove('fa-solid', 'fa-check');
      deleteTarget.setAttribute('data-delete-reserve', true);
    }

    this.handleWindowResize(event);
  }

  /**
   * コピー&ペーストイベント
   * @param {*} event 
   * @returns 
   */
  handleElementCopy(event) {
    event.stopPropagation();
    const targetElement = event.currentTarget.closest('.node');
    if (templateCopyItemStore.getState().templateCopyItem.id) {
      //ペーストの処理
      templateJsonStore.dispatch(copyElement({ originId: templateCopyItemStore.getState().templateCopyItem.id, prevElementId: targetElement.dataset.nodeId }))

      //　コピーした後のエレメントを選択状態にする
      //const pasteElement = findNextSibling(templateJsonStore.getState(), templateCopyItemStore.getState().templateCopyItem.id);
      const pasteElement = findNextSibling(templateJsonStore.getState(), targetElement.dataset.nodeId);

      const isTopTemplate = templateJsonStore.getState().templateJson.templates.some(template => template.id === pasteElement.id);

      if (isTopTemplate) {
        templateSelectedRootStore.dispatch(selectRoot(pasteElement.id));
        templateSelectedItemStore.dispatch(selectItem(pasteElement.id));
      } else {
        templateSelectedItemStore.dispatch(selectItem(pasteElement.id));
      }
      //コピー対象を解除
      templateCopyItemStore.dispatch(deselectCopyItem());
      this.changeCopyIcon();
    } else {
      //コピーの準備
      this.changePasteIcon();
      templateCopyItemStore.dispatch(selectCopyItem(targetElement.dataset.nodeId));
    }
    this.handleWindowResize(event);

  }

  /**
   * コピーアイコンをコピーにする
   */
  changeCopyIcon() {
    //コピーアイコンに変更
    const targetIcons = this.shadowRoot.querySelectorAll('.copy-icon i');
    targetIcons.forEach((targetIcon) => {
      const nodeElement = targetIcon.closest('.node');
      if (nodeElement.parentNode.id === 'dom-tree') {
        if (nodeElement.dataset.nodeType !== 'app') {
          targetIcon.parentNode.style.display = 'flex';
        }
      }

      targetIcon.classList.remove('fa-solid', 'fa-paste');
      targetIcon.classList.add('fa-regular', 'fa-copy');
      targetIcon.title = "コピー";
    });
  }

  /**
   * コピーアイコンをペーストにする
   */
  changePasteIcon() {
    //ペーストアイコンに変更
    const targetIcons = this.shadowRoot.querySelectorAll('.copy-icon i');

    targetIcons.forEach((targetIcon) => {
      const nodeElement = targetIcon.closest('.node');
      if (nodeElement.parentNode.id === 'dom-tree') {
        if (['page', 'dialog', 'action-sheet', 'toast', 'popover'].includes(nodeElement.dataset.nodeType)) {
          const pastItem = templateCopyItemStore.getState().templateCopyItem.item;
          if (pastItem) {
            const pastType = templateCopyItemStore.getState().templateCopyItem.item.tagName;
            if (!['ons-page', 'ons-dialog', 'ons-action-sheet', 'ons-toast', 'ons-popover'].includes(pastType)) {
              targetIcon.parentNode.style.display = 'none';
            }
          }
        }
      }

      targetIcon.classList.remove('fa-regular', 'fa-copy');
      targetIcon.classList.add('fa-solid', 'fa-paste');
      targetIcon.title = "ペースト";
      //<i class="fa-solid fa-paste"></i>
    });
  }

  handleOpenContextMenu(event) {
    event.stopPropagation();
    const hamburger = this.shadowRoot.getElementById("hamburger");
    const contextMenu = this.shadowRoot.getElementById("contextMenu");


    this.closeTemplateListPopup(event);
    this.handleCloseTrashBox(event);
    this.closeSearchSubWindow(event);
    if (contextMenu.style.display === "block") {
      this.handleCloseContextMenu(event);
      return;
    }

    // hamburgerの位置とサイズを取得
    const hamburgerRect = hamburger.getBoundingClientRect();

    // contextMenuの右上をhamburgerの中央に合わせる
    contextMenu.style.display = "block";
    contextMenu.style.left = (hamburgerRect.left + hamburgerRect.width / 2 - contextMenu.getBoundingClientRect().width) + "px";
    contextMenu.style.top = (hamburgerRect.top + hamburgerRect.height / 2 - 4) + "px";

  }

  handleCloseContextMenu(event) {
    //20240120
    event.stopPropagation();
    const contextMenu = this.shadowRoot.getElementById("contextMenu");
    if (contextMenu) {
      contextMenu.style.display = "none";
    }
  }

  handleAddPage(event) {
    event.stopPropagation();
    //const contextMenu = this.shadowRoot.getElementById("contextMenu");
    this.handleCloseContextMenu(event);
    this.handleCloseTrashBox(event);
    this.closeSearchSubWindow(event);
    const newUuid = v4();
    templateJsonStore.dispatch(addTemplate({
      newTemplate: {
        "id": newUuid, "tagName": "ons-page", "type": "page", "attributes": {},
        "children": [
          { "tagName": "div", "explain": "バックグラウンド", "attributes": { "class": "page__background" }, "children": [] },
          { "tagName": "div", "explain": "コンテンツ", "attributes": { "class": "page__content" }, "children": [] }
        ], "explain": "ページ"
      }
    }));
    templateSelectedRootStore.dispatch(selectRoot(newUuid));
    templateSelectedItemStore.dispatch(selectItem(newUuid));
    //contextMenu.style.display = "none";
  }

  handleAddDialog(event) {
    event.stopPropagation();
    //const contextMenu = this.shadowRoot.getElementById("contextMenu");
    this.handleCloseContextMenu(event);
    const newUuid = v4();
    templateJsonStore.dispatch(addTemplate({
      newTemplate: {
        "id": newUuid, "tagName": "ons-dialog", "type": "dialog", "attributes": { visible: true }, "children": [
          {
            "tagName": "div", "attributes": { "style": "\n    text-align: center;\n    padding: 10px;\n" },
            "children": [
              { "tagName": "p", "attributes": {}, children: [], "text": "Dialog message" },
              { "tagName": "ons-button", "explain": "ボタン", "attributes": {}, children: [], "text": "Close" }
            ]
          }
        ], "explain": "ダイアログ"
      }
    }));
    templateSelectedRootStore.dispatch(selectRoot(newUuid));
    templateSelectedItemStore.dispatch(selectItem(newUuid));
    //contextMenu.style.display = "none";
  }

  handleAddActionSheet(event) {
    event.stopPropagation();
    //const contextMenu = this.shadowRoot.getElementById("contextMenu");
    this.handleCloseContextMenu(event);
    const newUuid = v4();
    templateJsonStore.dispatch(addTemplate({
      newTemplate: {
        "id": newUuid, "tagName": "ons-action-sheet", "type": "action-sheet", "attributes": { visible: true, "title": "ActionSheet" },
        "children": [
          { "tagName": "ons-action-sheet-button", "explain": "アクションシートボタン", "attributes": { "icon": "fa-square-caret-down" }, children: [], "text": "Label" },
          { "tagName": "ons-action-sheet-button", "explain": "アクションシートボタン", "attributes": { "icon": "fa-square-caret-down" }, children: [], "text": "Label" },
          { "tagName": "ons-action-sheet-button", "explain": "アクションシートボタン", "attributes": { "icon": "fa-xmark" }, children: [], "text": "Cancel" },
        ], "explain": "アクションシート"
      }
    }));
    templateSelectedRootStore.dispatch(selectRoot(newUuid));
    templateSelectedItemStore.dispatch(selectItem(newUuid));
    //contextMenu.style.display = "none";
  }

  handleAddToast(event) {
    event.stopPropagation();
    this.handleCloseContextMenu(event);
    const newUuid = v4();
    templateJsonStore.dispatch(addTemplate({
      newTemplate: {
        "id": newUuid, "tagName": "ons-toast", "type": "toast", "attributes": { visible: true },
        "children": [
          { "tagName": "div", "explain": "メッセージ", "attributes": { "class": "toast__message" }, "children": [], "text": "トーストメッセージ" },
          { "tagName": "button", "explain": "閉じるボタン", "attributes": {}, "children": [], "text": "Close" },
        ], "explain": "トースト"
      }
    }));
    templateSelectedRootStore.dispatch(selectRoot(newUuid));
    templateSelectedItemStore.dispatch(selectItem(newUuid));
  }

  handleAddPopover(event) {
    event.stopPropagation();
    this.handleCloseContextMenu(event);
    const newUuid = v4();
    templateJsonStore.dispatch(addTemplate({
      newTemplate: {
        "id": newUuid, "tagName": "ons-popover", "type": "popover", "attributes": { visible: true, direction: "up" },
        "children": [
          { "tagName": "div", "explain": "コンテンツ", "attributes": { "style": "\n    padding: 10px;\n    text-align: center;\n" }, "children": [], "text": "ポップオーバーの内容" }
        ], "explain": "ポップオーバー"
      }
    }));
    templateSelectedRootStore.dispatch(selectRoot(newUuid));
    templateSelectedItemStore.dispatch(selectItem(newUuid));
  }

  handleSelectTemplate(event) {
    // イベントのバブリングを停止
    event.stopPropagation();

    this.closeTemplateListPopup(event);
    const selectedId = event.currentTarget.dataset.templateId;
    if (selectedId !== templateSelectedRootStore.getState().templateSelectedRoot.targetId) {
      templateSelectedRootStore.dispatch(selectRoot(selectedId));
      templateSelectedItemStore.dispatch(selectItem(selectedId));
    }
  }

  /**
   * テンプレートルートの並び替えのためのドラッグ操作開始
   * @param {*} event 
   */
  handleTemplateRootDragStart(event) {
    this.templateRootDragElement = event.target.parentElement;
    this.isDragging = true;
  }

  handleTemplateRootDragEnd(event) {
    //すべてのmove-pointを非表示状態にする
    Array.from(this.shadowRoot.querySelectorAll(".move-point")).forEach(movePoint => {
      movePoint.style.visibility = 'hidden';
    });

    if (this.templateRootOverElement && this.templateRootDragElement) {
      templateJsonStore.dispatch(moveAfter({ destId: this.templateRootOverElement.dataset.templateId, srcId: this.templateRootDragElement.dataset.templateId }));
    }
    this.templateRootOverElement = null;
    this.templateRootDragElement = null;
    this.isDragging = false;
  }

  handleTemplateRootDragOver(event) {
    if (this.templateRootDragElement) {
      // ドラッグ中のアイテムを取得
      const dragItem = this.templateRootDragElement.closest(".top-template-item");

      //ドロップ先の要素を取得
      const dropItem = event.target.closest(".top-template-item");

      //ドラッグ中のアイテムとドロップ先のアイテムが同じであれば何もしない
      if (dragItem === dropItem) {
        return;
      }

      // dragItemの属性キーを取得
      const dragTemplateId = dragItem.dataset.templateId;
      // dragItemのテンプレートタイプを取得
      const dragTemplateType = dragItem.dataset.templateType;
      // dropItemのテンプレートタイプを取得
      const dropTemplateType = dropItem.dataset.templateType;

      //すべてのmove-pointを非表示状態にする
      Array.from(this.shadowRoot.querySelectorAll(".move-point")).forEach(movePoint => {
        movePoint.style.visibility = 'hidden';
      });

      if (dropItem) {
        // dropItemの中央位置を取得
        const dropTargetElementCenter = dropItem.getBoundingClientRect().top + (dropItem.getBoundingClientRect().bottom - dropItem.getBoundingClientRect().top) / 2;

        const children = Array.from(dropItem.parentNode.children).filter(child => child.classList.contains("top-template-item"));

        const dragId = children.indexOf(dragItem);
        const dropId = children.indexOf(dropItem);
        let movePoint = null;
        // カーソル位置がdropTargetElementの中央より上でかつ、TOPより下の範囲にあればdropTargetElementの上側のmove-pointを有効にする
        if (event.clientY < dropTargetElementCenter && event.clientY >= dropItem.getBoundingClientRect().top) {
          //dropTemplateTypeがappの場合は何もしない
          if (dropTemplateType === 'app') return;

          //dropItemの上側の兄弟の位置のmove-pointを表示状態にする
          movePoint = dropItem.previousElementSibling
          //movePointのstyleのvisiblityをvisibleにする
          movePoint.style.visibility = 'visible';

          if (dragId < dropId) {
            //上から下へ移動
            this.dragNewIndex = children.indexOf(movePoint.previousElementSibling);
            //console.log("harf up 上から下へ移動 drop Index:{}, drag Index:{}", dropId, dragId);
          } else {
            //下から上へ移動
            this.dragNewIndex = children.indexOf(movePoint.nextElementSibling);
            //console.log("harf up 下から上へ移動 drop Index:{}, drag Index:{}", dropId, dragId);
          }

        }
        //カーソル位置がdropTargetElementの中央より下でかつ、bottomより上の範囲にあればdropTargetElementの下側のmove-pointを有効にする
        else if (event.clientY > dropTargetElementCenter && event.clientY < dropItem.getBoundingClientRect().bottom) {

          //dropItemの下側の兄弟の位置のmove-pointを表示状態にする
          movePoint = dropItem.nextElementSibling;
          //movePointのstyleのvisiblityをvisibleにする
          movePoint.style.visibility = 'visible';

          if (dragId < dropId) {
            // 上から下へ移動
            this.dragNewIndex = children.indexOf(movePoint.previousElementSibling);
            //console.log("harf down 上から下へ移動 drop Index:{}, drag Index:{}", dropId, dragId);
          } else {
            this.dragNewIndex = children.indexOf(movePoint.nextElementSibling);
            //console.log("harf down 下から上へ移動 drop Index:{}, drag Index:{}", dropId, dragId);
          }
        }

        // movePointの上側の兄弟であるtop-template-itemを取得する
        if (this.templateRootDragElement !== movePoint.previousElementSibling) {
          this.templateRootOverElement = movePoint.previousElementSibling;
        }
      }
    }
  }
  /**
   * コピー準備を解除
   * @param {*} event 
   */
  handleDeleteCopyItem(event) {
    this.changeCopyIcon();
    templateCopyItemStore.dispatch(deselectCopyItem());
    // this.requestUpdate();
  }

  /**
   * ゴミ箱を開く
   */
  handleOpenTrashBox(event) {
    event.stopPropagation();

    this.closeTemplatePopup(event);
    this.handleCloseContextMenu(event);

    const trashBox = this.shadowRoot.querySelector(".template-trash-box");
    trashBox.style.display = "flex";

    //class=fab-trash-boxを取得
    const fabTrashBox = this.shadowRoot.querySelector("#fab-trash-box");
    const fabTrashBoxRect = fabTrashBox.getBoundingClientRect();

    //trushBoxのleft上をfabTrashBoxの中心にする
    trashBox.style.left = fabTrashBoxRect.left + fabTrashBoxRect.width / 2 + "px";
    trashBox.style.top = fabTrashBoxRect.top + fabTrashBoxRect.height / 2 + "px";

    //trashBoxのbottomが画面より下側になるなら画面下部にする
    const trashBoxRect = trashBox.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    if (trashBoxRect.bottom > windowHeight) {
      trashBox.style.bottom = "0px";
      trashBox.style.top = "";
    }
    //trashBoxのtopが画面より上側になるなら画面上部にする
    if (trashBoxRect.top < 0) {
      trashBox.style.top = "0px";
      trashBox.style.bottom = "";
    }
    //trashBoxのleftが画面より左側になるなら画面左側にする
    if (trashBoxRect.left < 0) {
      trashBox.style.left = "0px";
      trashBox.style.right = "";
    }
    //trashBoxのrightが画面より右側になるなら画面右側にする
    const windowWidth = window.innerWidth;
    if (trashBoxRect.right > windowWidth) {
      trashBox.style.right = "0px";
      trashBox.style.left = "";
    }

  }

  /**
   * ゴミ箱を閉じる
   * @param {*} event 
   */
  handleCloseTrashBox(event) {
    const trashBox = this.shadowRoot.querySelector(".template-trash-box");
    trashBox.style.display = "none";
  }

  /**
   * テンプレートアイテムの展開と縮小をする
   * 
   * @param {Event} event 
   * @returns 
   */
  handleExpandAndCollapsed(event) {
    event.stopPropagation();
    const icon = event.currentTarget;
    // i要素の一番近い先祖のnodeを探す
    let node = icon.closest('.node');
    let expand = node.dataset.expand;
    if (expand === undefined || expand === null) expand = "true";
    if (expand === "true") {
      expand = true;
    } else if (expand === "false") {
      expand = false;
    } else {
      //エラーを出する
      console.error("expandの値が不正です");
      return;
    }

    templateJsonStore.dispatch(updateElementAttribute(
      { elementId: node.dataset.nodeId, attributeType: "expand", newValue: !expand }
    ));
  }

  /**
     * 空にするボタンの処理
     * @returns 
     */
  handleDeleteButton(event) {
    event.stopPropagation();

    //確認メッセージをを表示
    if (!confirm("ゴミ箱を空にしますか？")) {
      return;
    }
    templateJsonStore.dispatch(clearTrashbox());
  }

  render() {
    const trushBoxItems = templateJsonStore.getState().templateJson.trashbox;
    const selectedRootItem = templateSelectedRootStore.getState().templateSelectedRoot.item;

    // selectedRootItemのexplainを決定するロジック
    let selectedRootExplain = "";
    if (selectedRootItem) {
      selectedRootExplain = selectedRootItem.explain ? selectedRootItem.explain : selectedRootItem.domId;
      if (!selectedRootExplain || selectedRootExplain === "") {
        selectedRootExplain = selectedRootItem.tagName;
      }
    }

    return html`
      <template id="layout-template">
        <div class="node">
          <div class="node-title">
            <div class="node-title-left">
              <div class="label-id"></div>
              <div class="label-tag-container">
                <i class="expand-item fa-solid fa-caret-down" style="
                  border: 2px solid #8f8f8f;
                  color: #8f8f8f;
                  border-radius: 100%;
                  width: 16px;
                  font-size: 20px;
                  margin-right: 5px;
                  padding-left: 3px;
                ">
                </i>
                <div class="label-tag-name"></div>
                <div class="label-explain"></div>
              </div>
            </div>
            <div class="node-title-right">
            <div class="copy-icon" title="コピー">
                <i class="fa-regular fa-copy"></i>
              </div>
              <div class="clear-icon" title="削除">
                <i class="fa-regular fa-trash-can"></i>
              </div>
            </div>
          </div>
          <div class="node-add-point"><insert-point-tooltip></insert-point-tooltip></div>
        </div>
      </template>

      <!-- 検索窓 -->
      <template-search-sub-window @click="${(e) => e.stopPropagation()}"></template-search-sub-window>
      
      <div class="title-bar">
        <div class="title">レイアウト</div>
        <div class="title-icon-bar">
          <div class="title-icon-bar-left">
            <button class="title-icon-bar-button" title="レイアウト検索" @click="${this.showSearchSubWindow}"><i class="fa-solid fa-magnifying-glass"></i></button>
          </div>
          <div class="title-icon-bar-right">
            <!-- Undo/Redo ボタン -->
            <button class="title-icon-bar-button" title="元に戻す (Ctrl+Z)" ?disabled=${!this.canUndo} @click="${() => templateHistoryManager.undo(templateJsonStore)}"><i class="fa-solid fa-rotate-left"></i></button>
            <button class="title-icon-bar-button" title="やり直す (Ctrl+Shift+Z / Ctrl+Y)" ?disabled=${!this.canRedo} @click="${() => templateHistoryManager.redo(templateJsonStore)}"><i class="fa-solid fa-rotate-right"></i></button>
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="container" >
            <div class="top-container">
              <div class="select" @click=${this.openTemplateListPopup}>
                <div class="text-container">
                    <span class="select-text">${selectedRootExplain}</span>
                </div>
                <span class="select-arrow"></span>
              </div>

              <div class="top-template-list" id="top-template-list" style="display: ${this.showTemplatePopup ? 'block' : 'none'};"> 
                <!-- トップテンプレートリスト -->
                ${templateJsonStore.getState().templateJson.templates.map((template, index) => {
      let explain = template.explain ? template.explain : template.domId;
      if (!explain || explain === "") {
        explain = template.tagName;
      }
      const isSelected = template.id === templateSelectedRootStore.getState().templateSelectedRoot.targetId;
      const classNames = ["top-template-item"];
      if (isSelected) classNames.push("selected-template");

      return html`
                  <div class="${classNames.join(' ')}"  data-template-id="${template.id}" data-template-type="${template.type}" @click="${this.handleSelectTemplate}">
                    <div class="top-template-name">${explain}</div>
                  </div>
                  <div class="move-point"></div>
                `})}
              </div>


              <div class="hamburger-wrapper" id="hamburger" title="ページ追加">
                <div class="hamburger" @click="${this.handleOpenContextMenu}">
                  <i class="fa-solid fa-plus"></i>
                </div>
              </div>

              <div class="context-menu" id="contextMenu">
                <div class="menu-item" @click="${this.handleAddPage}">ページ追加</div>
                <div class="menu-item" @click="${this.handleAddDialog}">ダイアログ追加</div>
                <div class="menu-item" @click="${this.handleAddActionSheet}">アクションシート追加</div>
                <div class="menu-item" @click="${this.handleAddToast}">トースト追加</div>
                <div class="menu-item" @click="${this.handleAddPopover}">ポップオーバー追加</div>
              </div>

            </div>
            <div id="dom-tree"></div>
            <!-- 画面下部のアイテムウィンドウ -->
            
            <div id="item-window">
              <button id="fab-trash-box" title="ゴミ箱" class="fab fab-trash-box" @click="${this.handleOpenTrashBox}">
                <i class="fa-regular fa-trash-can"></i>
              </button >
              ${templateCopyItemStore.getState().templateCopyItem.id === null ? '' : html`
                <div class="display-item copy-item" @click="${(e) => e.stopPropagation()}">Copy: ${templateCopyItemStore.getState().templateCopyItem.item.domId}<i class="fa-solid fa-delete-left" @click="${this.handleDeleteCopyItem}"></i></div>
              `}   
            </div >

          <!-- ゴミ箱 -->
          <div class="template-trash-box" @click="${(e) => { e.stopPropagation(); }}">
            <div class="template-trash-box-sub-title">
                ${trushBoxItems.length !== 0 ? html`<button class="template-trash-box-delete-button" @click="${this.handleDeleteButton}">空にする</button>` : ""}
                <div class="template-trash-box-sub-title-text">ゴミ箱</div>
            </div>
            <div class="template-trash-box-panel">
            ${trushBoxItems.length === 0 ? html`
                <div class="template-trash-box-non-trash-container">
                    <div class="template-trash-box-non-trush-message">ゴミ箱は空です</div>
                </div>` : ""}
            ${trushBoxItems.map(trashBoxItem => {
        let explain = "";
        if (!trashBoxItem) {
          explain = "";
        } else if (trashBoxItem.explain !== "") {
          explain = trashBoxItem.explain;
        } else {
          explain = trashBoxItem.tagName;
        }

        return html`
            <div class="template-trash-box-node" data-node-id="${trashBoxItem.id}" data-node-type="${trashBoxItem.tagName}">
                <div class"node-title">
                    <div class="template-trash-box-label-id">id:${trashBoxItem.domId}</div>
                </div>
                <div class="template-trash-box-node-label-tag-container">
                    <div class="template-trash-box-node-label-explain">${explain}</div>
                </div>
            </div>`})}
            </div>
          </div>
        <div>
      </div>

      <!-- HTMLタグ選択ダイアログ -->
      <message-box id="html-tag-select-dialog" boxWidth="420px">
        <div slot="message-slot">
          <p style="text-align: center; font-weight: bold; margin-bottom: 15px; font-size: 15px; color: #333;">追加するHTMLタグを選択または入力</p>
          <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 20px;">
            ${['div', 'span', 'p', 'img', 'a', 'ul', 'li', 'br', 'h1', 'h2', 'h3', 'strong'].map(tag => html`
              <button type="button" class="title-icon-bar-button" style="width: 100%; height: 35px; border-radius: 4px; font-size: 13px; font-weight: bold; display: flex; align-items: center; justify-content: center; border: 1px solid #ccc; background: white; cursor: pointer;" @click="${() => this._selectPresetTag(tag)}">${tag}</button>
            `)}
          </div>
          <div style="display: flex; flex-direction: column; gap: 8px; text-align: left;">
            <label for="custom-tag-input" style="font-size: 12px; font-weight: bold; color: #555;">その他のタグを手入力:</label>
            <input type="text" id="custom-tag-input" placeholder="例: section, article" @keydown="${this._handleCustomTagKeydown}" style="width: 100%; box-sizing: border-box; padding: 10px; border: 1px solid #ccc; border-radius: 5px; font-size: 14px;">
          </div>
        </div>
        <button slot="ok-slot" class="confirm-ok-button" style="background-color: #007bff; border: none; padding: 10px 16px; border-radius: 6px; font-weight: 600; color: white; cursor: pointer;">追加</button>
        <button slot="cancel-slot" class="confirm-cancel-button" style="background-color: #f3f4f6; color: #374151; border: none; padding: 10px 16px; border-radius: 6px; font-weight: 600; cursor: pointer;">キャンセル</button>
      </message-box>
      `;
  }
}

customElements.define('template-container', TemplateContainer);